// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.NodeInfo_node__EjevV {
  width: 380px;
  border: 1px solid black;
  border-radius: 4px;
}
.NodeInfo_node__EjevV[data-active=true] {
  border-color: #5CB85C;
}
.NodeInfo_node__EjevV[data-active=false] {
  border-color: #F0AD4E;
}
.NodeInfo_node__EjevV[data-error=true] {
  border-color: #C12B2B;
}
.NodeInfo_node__EjevV[data-removed=true] {
  border-color: lightgray;
}

.NodeInfo_status-bar__k\\+Far {
  display: flex;
  align-items: center;
  padding: 4px;
  height: 32px;
}
.NodeInfo_status-bar__k\\+Far[data-active=true] {
  background-color: #5CB85C;
}
.NodeInfo_status-bar__k\\+Far[data-active=false] {
  background-color: #F0AD4E;
}
.NodeInfo_status-bar__k\\+Far[data-error=true] {
  background-color: #C12B2B;
}
.NodeInfo_status-bar__k\\+Far[data-removed=true] {
  background-color: lightgray;
}

.NodeInfo_controls-box__sMNxG {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 4px;
}

.NodeInfo_status-text__6eyNz {
  text-transform: uppercase;
  font-weight: bold;
  color: white;
  padding: 0px 8px;
}

.NodeInfo_contents__9pwyj {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px;
}

.NodeInfo_no-data__BF32E {
  background-color: #f1f1f1;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 68px;
}

.NodeInfo_separator__Ys4zm {
  width: 1px;
  height: 24px;
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/NodeInfo/NodeInfo.module.scss","webpack://./src/utils/_utils.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;AEzBA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AD/BA;EACE,YAAA;EAEA,uBAAA;EACA,kBAAA;AAqBF;AAnBE;EACE,qBAAA;AAqBJ;AAnBE;EACE,qBAAA;AAqBJ;AAnBE;EACE,qBAAA;AAqBJ;AAnBE;EACE,uBAAA;AAqBJ;;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAoBF;AAlBE;EACE,yBAAA;AAoBJ;AAlBE;EACE,yBAAA;AAoBJ;AAlBE;EACE,yBAAA;AAoBJ;AAlBE;EACE,2BAAA;AAoBJ;;AAhBA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;AAmBF;;AAhBA;EACE,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAmBF;;AAhBA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAmBF;;AAhBA;EACE,UAAA;EACA,YAAA;EACA,uBAAA;AAmBF","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.node {\n  width: 380px;\n  border: 1px solid black;\n  border-radius: 4px;\n}\n.node[data-active=true] {\n  border-color: #5CB85C;\n}\n.node[data-active=false] {\n  border-color: #F0AD4E;\n}\n.node[data-error=true] {\n  border-color: #C12B2B;\n}\n.node[data-removed=true] {\n  border-color: lightgray;\n}\n\n.status-bar {\n  display: flex;\n  align-items: center;\n  padding: 4px;\n  height: 32px;\n}\n.status-bar[data-active=true] {\n  background-color: #5CB85C;\n}\n.status-bar[data-active=false] {\n  background-color: #F0AD4E;\n}\n.status-bar[data-error=true] {\n  background-color: #C12B2B;\n}\n.status-bar[data-removed=true] {\n  background-color: lightgray;\n}\n\n.controls-box {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: right;\n  gap: 4px;\n}\n\n.status-text {\n  text-transform: uppercase;\n  font-weight: bold;\n  color: white;\n  padding: 0px 8px;\n}\n\n.contents {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 4px;\n}\n\n.no-data {\n  background-color: #f1f1f1;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 68px;\n}\n\n.separator {\n  width: 1px;\n  height: 24px;\n  background-color: white;\n}",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"node": `NodeInfo_node__EjevV`,
	"status-bar": `NodeInfo_status-bar__k+Far`,
	"controls-box": `NodeInfo_controls-box__sMNxG`,
	"status-text": `NodeInfo_status-text__6eyNz`,
	"contents": `NodeInfo_contents__9pwyj`,
	"no-data": `NodeInfo_no-data__BF32E`,
	"separator": `NodeInfo_separator__Ys4zm`
};
export default ___CSS_LOADER_EXPORT___;
